// SALUTATIONS.js
import { t } from "i18next";

export const SALUTATIONS = () => [
  { value: "Mr.", label: t("Contacts.salutation_types.mr") },
  { value: "Mrs.", label: t("Contacts.salutation_types.mrs") },
  { value: "Ms.", label: t("Contacts.salutation_types.ms") },
  { value: "Miss", label: t("Contacts.salutation_types.miss") },
  { value: "Dr.", label: t("Contacts.salutation_types.dr") },
];


export default SALUTATIONS